import React from 'react';
import { RequestVehiclePurchaseUi } from './ui/RequestVehiclePurchaseUi';

export const RequestVehiclePurchase = () => {
    return <RequestVehiclePurchaseUi />;
};
